import React, { useEffect, useState } from "react";
import Layout from "../hocs/layout/Layout";
import { motion, AnimatePresence } from "framer-motion";
import { Card, Row, Col, Form } from "react-bootstrap";
import { RootState } from "../../store";
import { connect, useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import { Objeto } from "../../components/Navegacion/Profile";
import { kpisActions } from "../../redux/actions/Dashboard/kpisActions";

import { categoriaActions } from "../../redux/actions/Dashboard/categoriaActions";
import { ubicacionActions } from "../../redux/actions/Dashboard/ubicacionActions";
import { bajasActions } from "../../redux/actions/Dashboard/bajasActions";
import { evolucionInventarioActions } from "../../redux/actions/Dashboard/evolucionInventarioActions";

import UbicacionBarChart from "../../components/Dashboard/UbicacionBarChart";
import EvolucionInventarioChart from "../../components/Dashboard/EvolucionInventarioChart";
import ValorContableChart, { DepreciacionInventarioItem } from "../../components/Dashboard/ValorContableChart";
import { useLocation, useNavigate } from "react-router-dom";
import BajasChart from "../../components/Dashboard/BajasChart";
import CategoriasChart from "../../components/Dashboard/CategoriasChart";
import { setAnioSeleccionadoActions } from "../../redux/actions/Dashboard/datosPersistidosActions";
import { depreciacionDashboardActions } from "../../redux/actions/Dashboard/depreciacionDashboardActions";
import { InventarioCompleto as InventarioCompletoDepreciacion } from "../../components/Inventario/ModificarInventario";
import { listaAltasRegistradasActions } from "../../redux/actions/Altas/AnularAltas/listaAltasRegistradasActions";
import { ListaAltas } from "../../components/Altas/RegistrarAltas";

// import Select from "react-select";


export interface GraficosProps {
  coD_UBICACION: number;
  ubicacion: string;
  categoria: string;
  cantidad: number;
  porcentaje: number;
}

export interface EvolucionInventarioProps {
  mes: string;
  altas: number;
  bajas: number;
  totaL_ACTIVOS: number;
  valoR_CONTABLE: number;
}

export interface DashboardProps {

  // KPIs
  totaL_ACTIVOS: number;
  total_ALTAS: number;
  total_BAJAS: number;
  total_BODEGA: number;
  total_REMATE: number;
  total_TRASLADOS: number;
  valor_INVENTARIO: number;
  totaL_EN_USO?: number;
  porcentajE_EN_USO?: number;
  aF_FINGRESO?: string;

  kpisActions: (anioSeleccionado: number, estabL_CORR: number) => Promise<boolean>;
  categoriaActions: (anioSeleccionado: number, estabL_CORR: number) => Promise<boolean>;
  ubicacionActions: (anioSeleccionado: number, estabL_CORR: number) => Promise<boolean>;
  bajasActions: (anioSeleccionado: number, estabL_CORR: number) => Promise<boolean>;
  evolucionInventarioActions: (anioSeleccionado: number, mesSeleccionado: string, estabL_CORR: number) => Promise<boolean>;
  listaAltasRegistradasActions: (fDesde: string, fHasta: string, af_codigo_generico: string, altasCorr: number, idocumento: number, establ_corr: number) => Promise<Array<ListaAltas> | null>,
  depreciacionDashboardActions: (activosSeleccionados: Record<string, any>[]) => Promise<Array<InventarioCompletoDepreciacion> | null>;
  //Gráficos
  categoriaDashboard: GraficosProps[];
  ubicacionDashboard: GraficosProps[];
  bajasDashboard: GraficosProps[];
  evolucionInventarioDashboard: EvolucionInventarioProps[];
  depreciacionInventarioDashboard: DepreciacionInventarioItem[];
  objeto: Objeto;
  anio_guardado: number;
  isDarkMode: boolean;
}

const Dashboard: React.FC<DashboardProps> = ({

  // Actions
  kpisActions,
  categoriaActions,
  ubicacionActions,
  bajasActions,
  evolucionInventarioActions,
  listaAltasRegistradasActions,
  depreciacionDashboardActions,
  // KPIs
  totaL_ACTIVOS,
  total_ALTAS,
  total_BAJAS,
  // total_BODEGA,
  // total_REMATE,
  // total_TRASLADOS,
  valor_INVENTARIO,
  // totaL_EN_USO,
  porcentajE_EN_USO,

  // Graficos
  categoriaDashboard,
  ubicacionDashboard,
  bajasDashboard,
  evolucionInventarioDashboard,
  depreciacionInventarioDashboard,
  // Usuario
  objeto,
  anio_guardado,
  isDarkMode

}) => {

  const navigate = useNavigate();
  const [anioSeleccionado, setAnioSeleccionado] = useState<number>(new Date().getFullYear());

  const dispatch = useDispatch();
  const anioActual = new Date().getFullYear();

  const anios = Array.from(
    { length: anioActual - 2024 + 1 },
    (_, index) => anioActual - index
  );
  const location = useLocation();
  const dashboard_mes = location.state?.dashboard_mes ?? 0;

  useEffect(() => {

    if (totaL_ACTIVOS === 0) {
      kpisActions(anioActual, objeto.Roles[0].codigoEstablecimiento);
    }
    if (categoriaDashboard.length === 0) {
      categoriaActions(anioActual, objeto.Roles[0].codigoEstablecimiento);
    }
    if (ubicacionDashboard.length === 0) {
      ubicacionActions(anioActual, objeto.Roles[0].codigoEstablecimiento);
    }
    if (bajasDashboard.length === 0) {
      bajasActions(anioActual, objeto.Roles[0].codigoEstablecimiento);
    }
    if (evolucionInventarioDashboard.length === 0) {
      evolucionInventarioActions(anioActual, "0", objeto.Roles[0].codigoEstablecimiento);

    }
    filtroDashboardUbicacion();

  }, [
    objeto,
    kpisActions,
    categoriaActions,
    ubicacionActions,
    bajasActions,
    evolucionInventarioActions,
    setAnioSeleccionadoActions,
    anio_guardado

  ]);

  const filtroDashboardUbicacion = async () => {
    // const resultado = await listaInventarioBuscarActions("", `${anioActual}-09-23`, `${anioActual}-09-23`, 0, 0, "", "", "", "", "", "", 0, objeto.Roles[0].codigoEstablecimiento, false);
    const resultado = await listaAltasRegistradasActions(`${anioActual}-01-01`, `${anioActual}-12-31`, "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
    depreciacionDashboardActions(resultado ?? []);
  };

  const tieneCategorias = Array.isArray(categoriaDashboard) && categoriaDashboard.length > 0;
  const tieneUbicaciones = Array.isArray(ubicacionDashboard) && ubicacionDashboard.length > 0;
  const tieneBajas = Array.isArray(bajasDashboard) && bajasDashboard.length > 0;
  const tieneEvolucionInventario = Array.isArray(evolucionInventarioDashboard) && evolucionInventarioDashboard.length > 0;
  const tieneDepreciacion = Array.isArray(depreciacionInventarioDashboard) && depreciacionInventarioDashboard.length > 0;


  const categoriasChart = categoriaDashboard.map(
    (categoria) => ({
      label: categoria.categoria,
      value: categoria.cantidad,
      percentage: categoria.porcentaje,

    })
  );

  const ubicacionesChart = ubicacionDashboard.map(
    (ubicacion) => ({
      depCorr: Number(ubicacion.coD_UBICACION) || 0,
      label: ubicacion.ubicacion,
      value: ubicacion.cantidad,
      percentage: ubicacion.porcentaje,

    })
  );

  const bajasChart = bajasDashboard.map(
    (bajas) => ({

      label: bajas.ubicacion,
      value: bajas.cantidad,
      percentage: bajas.porcentaje,

    })
  );


  const evolucionInventarioChart = evolucionInventarioDashboard.map((item) => ({
    mes: item.mes,
    meses: item.mes,
    altas: Number(item.altas) || 0,
    bajas: Number(item.bajas) || 0,
    totaL_ACTIVOS: Number(item.totaL_ACTIVOS) || 0,
    valoR_CONTABLE: Number(item.valoR_CONTABLE) || 0,
    valorContable: Number(item.valoR_CONTABLE) || 0,
  }));

  const depreciacionInventarioChart = depreciacionInventarioDashboard.map((item) => ({
    mes: item.mes,
    nombreMes: item.nombreMes,
    cantidadBienes: item.cantidadBienes,
    cantidadBienesNoDepreciables: item.cantidadBienesNoDepreciables,
    valorCompra: item.valorCompra,
    valorDepreciado: Number(item.valorDepreciado) || 0,
    depreciacionAcumulada: item.depreciacionAcumulada || 0

  }));



  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { value } = e.target;

    setAnioSeleccionado(Number(value)); //aqui guardamos el año en el estado local
    dispatch(setAnioSeleccionadoActions(Number(value)));//aqui guardamos el año en estado persistente

    kpisActions(Number(value), objeto.Roles[0].codigoEstablecimiento);
    categoriaActions(Number(value), objeto.Roles[0].codigoEstablecimiento);
    ubicacionActions(Number(value), objeto.Roles[0].codigoEstablecimiento);
    bajasActions(Number(value), objeto.Roles[0].codigoEstablecimiento);
    evolucionInventarioActions(Number(value), dashboard_mes === 0 ? "0" : dashboard_mes, objeto.Roles[0].codigoEstablecimiento);
    const resultado = await listaAltasRegistradasActions(`${anioActual}-01-01`, `${anioActual}-12-31`, "", 0, 0, objeto.Roles[0].codigoEstablecimiento);
    depreciacionDashboardActions(resultado ?? []);
  };

  const handleEvolucionClick = (tipo: string, mesSeleccionado: string) => {

    if (tipo === "ALTAS") {
      navigate("/Altas/FirmarAltas", {
        state: { dashboard_mes: mesSeleccionado, dashboard_anio: anioSeleccionado, dashboard_evolucion: true }
      });
    }

    if (tipo === "BAJAS") {
      navigate("/Bajas", {
        state: { dashboard_mes: mesSeleccionado, dashboard_anio: anioSeleccionado, dashboard_evolucion: true }
      });
    }
    if (tipo === "TOTAL_ACTIVOS") {
      navigate("/Inventario/BuscarInventario", {
        state: { dashboard_mes: mesSeleccionado, dashboard_anio: anioSeleccionado, dashboard_evolucion: true }
      });
    }
  };

  const handleDependenciaClick = (depCorr: number) => {

    navigate("/Inventario/BuscarInventario", {
      state: { dashboard_dep_corr: depCorr, dashboard_anio: anioSeleccionado, dashboard_ubicacion: true }
    });
  };

  const handleDependenciaBajasClick = (opcion: string) => {

    if (opcion === "Bodega de Excluidos") {
      navigate("/Bajas/BodegaExcluidos", {
        state: { dashboard_anio: anioSeleccionado }
      });
    }
    else {
      navigate("/Bajas/BienesRematados", {
        state: { dashboard_anio: anioSeleccionado }
      });
    }
  };


  return (
    <Layout>

      <Helmet>
        <title>Dashboard</title>
      </Helmet>

      <AnimatePresence mode="wait">
        <motion.div initial={{ x: -100 }} animate={{ x: 0 }} exit={{ x: 100 }}
          transition={{ duration: 0.3 }}>
          <div className="px-5 container-fluid mt-0">

            {/* KPI */}
            <Row className="g-3 mb-4">

              {/* TOTAL ACTIVOS */}
              <Col lg={3} md={4} sm={6}>
                <div className={`bg-color border-secondary shadow-sm p-lg-3 p-sm-1 rounded m-2`}>
                  <p className={`text-uppercase fw-semibold small mb-1 text-center text-white `}>
                    Total de Activos
                  </p>
                  <h4 className="fw-bold text-secondary text-center text-white m-0">
                    {totaL_ACTIVOS.toLocaleString("es-ES", {
                      maximumFractionDigits: 0,
                    })}
                  </h4>
                </div>
              </Col>


              {/* VALOR INVENTARIO */}
              <Col lg={3} md={4} sm={6}>
                <div className={`bg-color  border-secondary shadow-sm p-lg-3 p-sm-1 rounded m-2`}>
                  <p className={`text-uppercase fw-semibold small mb-1 text-center text-white`}>
                    Valor Inventario
                  </p>
                  <h4 className="fw-bold text-secondary text-center text-white m-0">
                    $ {valor_INVENTARIO.toLocaleString("es-ES", {
                      maximumFractionDigits: 0,
                    })}
                  </h4>
                </div>
              </Col>

              {/* ALTAS */}
              <Col lg={2} md={4} sm={6}>
                <div className={`bg-success  border-secondary shadow-sm p-lg-3 p-sm-1 rounded m-2 `}>
                  <p className={`text-uppercase fw-semibold small mb-1 text-center text-white`}>
                    Altas
                  </p>
                  <h4 className="fw-bold text-secondary text-center text-white m-0">
                    {total_ALTAS.toLocaleString("es-ES", {
                      maximumFractionDigits: 0,
                    })}
                  </h4>
                </div>
              </Col>
              {/* BAJAS */}
              <Col lg={2} md={4} sm={6}>
                <div className={`bg-danger  border-secondary shadow-sm p-lg-3 p-sm-1 rounded m-2 `}>
                  <p className={`text-uppercase fw-semibold small mb-1 text-center text-white `}>
                    Bajas
                  </p>
                  <h4 className="fw-bold text-secondary text-center text-white m-0">
                    {total_BAJAS.toLocaleString("es-ES", {
                      maximumFractionDigits: 0,
                    })}
                  </h4>
                </div>
              </Col>
              {/* BODEGA */}
              {/* <Col lg={2} md={4} sm={6}>
                <Card className="shadow-sm text-center h-100 p-3">
                  <div className="text-muted small">
                    Bodega de Excluidos
                  </div>
                  <h4 className="text-warning mb-0">
                    {total_BODEGA?.toLocaleString(
                      "es-ES",
                      {
                        minimumFractionDigits: 0
                      }
                    )}
                  </h4>
                </Card>
              </Col> */}
              {/* REMATE */}
              {/* <Col lg={2} md={4} sm={6}>
                <Card className="shadow-sm text-center h-100 p-3">
                  <div className="text-muted small">
                    Remates
                  </div>
                  <h4 className="text-danger mb-0">
                    {total_REMATE?.toLocaleString(
                      "es-ES",
                      {
                        minimumFractionDigits: 0
                      }
                    )}
                  </h4>
                </Card>
              </Col> */}

              {/* EN USO */}
              <Col lg={2} md={4} sm={6}>
                <div className={`bg-color  border-secondary shadow-sm p-lg-3 p-sm-1rounded m-2`}>
                  <p className={`text-uppercase fw-semibold small mb-1 text-center text-white`}>
                    En Uso
                  </p>
                  <h4 className="fw-bold text-secondary text-center text-white m-0">
                    {porcentajE_EN_USO?.toLocaleString("es-ES", {
                      maximumFractionDigits: 0,
                    })} %
                  </h4>
                </div>
              </Col>

            </Row>

            <Row className=" mb-3 g-2 align-items-end justify-content-center">

              <Col md={2}>
                <p className="fw-semibold me-1 text-center ">Filtrar por año: </p>
                <div className="d-flex align-items-center ">
                  <Form.Select

                    className={`form-select  ${isDarkMode ? "bg-dark text-light" : ""}`}
                    onChange={handleChange}
                    value={anio_guardado}
                  >
                    {anios.map((anio) => (
                      <option key={anio} value={anio}>
                        {anio}
                      </option>
                    ))}

                  </Form.Select>
                </div>
              </Col>


            </Row>

            {/* DASHBOARD */}
            <Row className="g-3 mb-3">

              {/* EVOLUCIÓN INVENTARIO */}
              <Col lg={5}>
                <Card className={`shadow-sm h-100 ${isDarkMode ? "text-light" : ""}`} style={{ backgroundColor: isDarkMode ? "#30353a" : "" }} >
                  <Card.Body>

                    <Card.Title className="fw-bold">
                      Evolución del Inventario
                    </Card.Title>

                    {tieneEvolucionInventario ? (

                      <EvolucionInventarioChart
                        data={evolucionInventarioChart}
                        onEvolucionClick={handleEvolucionClick}
                        title="Evolución del Inventario"
                      />

                    ) : (

                      <div className="text-center d-flex align-items-center justify-content-center"
                        style={{ height: "320px" }}
                      >
                        <div>
                          <i
                            className="bi bi-bar-chart-line"
                            style={{ fontSize: "2rem" }}
                          />

                          <p className="mb-0 mt-2">
                            Cargando evolución del inventario...
                          </p>
                        </div>
                      </div>

                    )}

                  </Card.Body>
                </Card>
              </Col>

              {/* DISTRIBUCIÓN POR CATEGORÍA */}
              <Col lg={3} >
                <Card className={`shadow-sm h-100 ${isDarkMode ? "text-light" : ""}`} style={{ backgroundColor: isDarkMode ? "#30353a" : "" }} >
                  <Card.Body>
                    <Card.Title className="fw-bold">
                      Distribución por Categoría
                    </Card.Title>
                    {tieneCategorias ? (

                      <div style={{
                        height: "350px",
                        width: "100%",
                        // backgroundColor: isDarkMode ? "#30353a" : ""

                      }}>

                        <CategoriasChart data={categoriasChart}
                          title="Inventario por Categoría"
                        />
                      </div>

                    ) : (

                      <div className="text-center text-muted py-5">
                        <p className="mb-0">
                          Cargando categorías...
                        </p>
                      </div>

                    )}
                  </Card.Body>
                </Card>
              </Col>
              {/* BIENES POR UBICACIÓN */}
              <Col lg={4}>
                <Card className={`shadow-sm  ${isDarkMode ? "text-light" : ""}`} style={{ backgroundColor: isDarkMode ? "#30353a" : "" }} >
                  <Card.Body className="d-flex flex-column justify-content-center text-start h-100 border-0 " >
                    <Card.Title className="fw-bold">
                      Bienes por Ubicación
                    </Card.Title>
                    {tieneUbicaciones ? (
                      <div style={{

                        // color: isDarkMode ? "#ffffff" : "",

                      }}>
                        <UbicacionBarChart
                          data={ubicacionesChart}
                          onDependenciaClick={handleDependenciaClick}
                          title="Bienes por Ubicación"
                          horizontal={true}
                        />
                      </div>
                    ) : (
                      <div className="text-center text-muted py-5">
                        <p className="mb-0">Cargando ubicaciones...</p>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>

            </Row>
            {/* SEGUNDA FILA */}
            <Row className="g-3 mb-3">
              {/* DEPRECIACIÓN DEL INVENTARIO */}
              <Col lg={9}>
                <Card className={`shadow-sm h-100 ${isDarkMode ? "text-light" : ""}`} style={{ backgroundColor: isDarkMode ? "#30353a" : "" }} >
                  <Card.Body>

                    <Card.Title className="fw-bold">
                      Valor Contable
                    </Card.Title>

                    {tieneDepreciacion ? (

                      <ValorContableChart
                        depreciacionMensual={depreciacionInventarioChart}
                        title="Valor de Compra"
                      />

                    ) : (

                      <div
                        className="text-center text-muted d-flex align-items-center justify-content-center"
                        style={{ height: "320px" }}
                      >
                        <div>
                          <i
                            className="bi bi-bar-chart-line"
                            style={{ fontSize: "2rem" }}
                          />

                          <p className="mb-0 mt-2">
                            Cargando Valor de Compra...
                          </p>
                        </div>
                      </div>

                    )}

                  </Card.Body>
                </Card>
              </Col>

              {/* BAJAS */}
              <Col lg={3}>
                <Card className={`shadow-sm ${isDarkMode ? "text-light" : ""}`} style={{ backgroundColor: isDarkMode ? "#30353a" : "" }} >
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <Card.Title className="fw-bold">
                      Bajas de Inventario
                    </Card.Title>
                    {tieneBajas ? (

                      <div style={{
                        height: "300px"
                      }}>

                        <BajasChart
                          data={bajasChart}
                          onDependenciaBajasClick={handleDependenciaBajasClick}
                          type="doughnut"
                          title="Inventario por Categoría"
                        />
                      </div>

                    ) : (

                      <div className="text-center text-muted py-5">
                        <p className="mb-0">
                          Cargando bajas...
                        </p>
                      </div>

                    )}
                  </Card.Body>
                </Card>
              </Col>


            </Row>
            {/* TERCERA FILA */}
            {/* <Row className="g-3 mb-3">            
              <Col lg={6}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title className="fw-bold">
                      Movimientos del Inventario
                    </Card.Title>
                    <div className="text-center text-muted py-5">
                      Próximamente
                    </div>
                  </Card.Body>
                </Card>
              </Col>
             
              <Col lg={3}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title className="fw-bold">
                      Depreciación
                    </Card.Title>
                    <div className="text-center text-muted py-5">
                      Próximamente
                    </div>
                  </Card.Body>
                </Card>
              </Col>
          
              <Col lg={3}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title className="fw-bold">
                      Alertas
                    </Card.Title>
                    <ul className="mb-0 small">
                      <li>
                        Próximos a depreciación total
                      </li>
                      <li>
                        Sin movimiento en 6 meses
                      </li>
                      <li>
                        Sin responsable asignado
                      </li>
                    </ul>
                  </Card.Body>

                </Card>
              </Col>
            </Row> */}

          </div>

        </motion.div>
      </AnimatePresence>

    </Layout >
  );
};

const mapStateToProps = (
  state: RootState
) => ({

  //KPYS
  totaL_ACTIVOS: state.kpisReducers.totaL_ACTIVOS,
  total_ALTAS: state.kpisReducers.total_ALTAS,
  total_BAJAS: state.kpisReducers.total_BAJAS,
  total_BODEGA: state.kpisReducers.total_BODEGA,
  total_REMATE: state.kpisReducers.total_REMATE,
  total_TRASLADOS: state.kpisReducers.total_TRASLADOS,
  valor_INVENTARIO: state.kpisReducers.valor_INVENTARIO,
  totaL_EN_USO: state.kpisReducers.totaL_EN_USO,
  porcentajE_EN_USO: state.kpisReducers.porcentajE_EN_USO,

  //Graficos
  categoriaDashboard: state.categoriaReducers.categoriaDashboard || [],
  ubicacionDashboard: state.ubicacionReducers.ubicacionDashboard || [],
  bajasDashboard: state.bajasReducers.bajasDashboard || [],
  evolucionInventarioDashboard: state.evolucionInventarioReducers.evolucionInventario || [],
  depreciacionInventarioDashboard: state.depreciacionInventarioReducers.depreciacionInventario || [],

  //otros
  objeto: state.validaApiLoginReducers,
  anio_guardado: state.datosPersistidosReducers.anio,
  isDarkMode: state.darkModeReducer.isDarkMode,

});

export default connect(mapStateToProps, {
  kpisActions,
  categoriaActions,
  ubicacionActions,
  bajasActions,
  evolucionInventarioActions,
  listaAltasRegistradasActions,
  depreciacionDashboardActions
}
)(Dashboard);